import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StatusJornada } from '../enums/Jornada/StatusJornada';

@Injectable({
  providedIn: 'root'
})
export class RelogioPontoService {

  private modalIniciarJornadaSubject = new BehaviorSubject<boolean>(false);
  private modalFinalizarJornadaSubject = new BehaviorSubject<boolean>(false);
  private suprimirPromptDeslocamentoNoProximoInicio = false;

  private statusJornadaSignal = signal<StatusJornada>(StatusJornada.NaoIniciada);
  public dataFim?:Date  ;
  modalIniciarJornada$ = this.modalIniciarJornadaSubject.asObservable();
  modalFinalizarJornada$ = this.modalFinalizarJornadaSubject.asObservable();

  abrirModalIniciarJornada() {
    this.modalIniciarJornadaSubject.next(true);
  }

  fecharModalIniciarJornada() {
    this.modalIniciarJornadaSubject.next(false);
  }

  abrirModalFinalizarJornada(dataFinal?: Date | string) {
    if (!dataFinal) {
      this.dataFim = new Date();
    } else {
      const data = dataFinal instanceof Date ? dataFinal : new Date(dataFinal);
      this.dataFim = Number.isNaN(data.getTime()) ? new Date() : data;
    }
    this.modalFinalizarJornadaSubject.next(true);
  }

  fecharModalFinalizarJornada() {
    this.dataFim = undefined;
    this.modalFinalizarJornadaSubject.next(false);
  }

  suprimirPromptDeslocamentoNoProximoInicioJornada() {
    this.suprimirPromptDeslocamentoNoProximoInicio = true;
  }

  consumirSupressaoPromptDeslocamentoNoInicioJornada(): boolean {
    const deveSuprimir = this.suprimirPromptDeslocamentoNoProximoInicio;
    this.suprimirPromptDeslocamentoNoProximoInicio = false;
    return deveSuprimir;
  }


  get statusJornada() {
    return this.statusJornadaSignal.asReadonly();
  }

  updateStatusJornada(status: StatusJornada) {
    this.statusJornadaSignal.set(status);
  }

}
